module.exports = __webpack_public_path__ + "static/media/masi.6cb1516f.JPG";